module.exports = __webpack_public_path__ + "img/capacity.3d784472.png";